<template lang="pug">
.wt-entity-list
  WtTitle.wt-entity-list-title(card-title).mb-4 {{ title }}
  WtRouterLink.is-size-7.wt-entity-list-view-all(
    :to="to"
  ) View All
  .wt-entity-list-featured.mb-4(v-if="hasFeatured")
    .has-text-grey.mb-3
      slot(name='featuredTitle')
    slot(name='featured')
  .wt-entity-list-body
    .wt-entity-list-body-heading.has-text-grey.mb-3(v-if="!_.isEmpty(bodyHeading)") {{ bodyHeading }}
    template(
      v-for="item in dataFiltered"
    )
      .wt-entity-list-body-item
        WtRouterLink.is-flex.has-text-grey-dark(
          :to="link.name"
          :params="{ [link.key]: entityId(item) }"
          type="list"
        )
          WtEntityAvatar.wt-entity-list-body-item-avatar.mr-3(v-if="imageKey" :image="item[imageKey]" size-class="is-48x48" is-rounded)
          .wt-entity-list-body-item-text
            .wt-entity-list-body-item-title {{ item.name }}
            .wt-entity-list-body-item-subtitle.is-size-7.has-text-grey {{ item.subtitle }}
  WtButton.wt-entity-list-footer(
    isRouterLink
    v-if="footer.display"
    :to="to"
    size="small"
  ) {{ footer.text }}

</template>

<script>
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import WtEntityAvatar from "@@/WtEntityAvatar/WtEntityAvatar";
import WtTitle from "@@/WtTitle/WtTitle";
import WtRouterLink from "@@/WtRouterLink/WtRouterLink";
import WtButton from "@@/WtButton/WtButton";

export default {
  name: "WtEntityList",

  components: { WtTitle, WtRouterLink, WtButton, WtEntityAvatar },

  mixins: [dateUtilityMixin],

  props: {
    entityType: {
      type: String,
      required: true
    },

    data: {
      type: Array,
      required: true
    },

    paginated: {
      type: Boolean,
      default: false
    },

    pageSize: {
      type: Number,
      default: 5
    },

    noItemsText: {
      type: Object,
      default: () => ({ display: true, text: "No items." })
    },

    footer: {
      type: Object,
      default: () => ({ display: false, text: "" })
    },

    title: {
      type: String,
      required: true
    },

    to: {
      type: String,
      required: true
    },

    hasFeatured: {
      type: Boolean,
      default: false
    },

    bodyHeading: {
      type: String,
      default: ""
    }
  },

  computed: {
    link() {
      const to = this.to.replace(/s$/, "");
      return {
        name: to,
        key: ["Challenge", "Team"].includes(to) ? `${to.toLowerCase()}Id` : "id"
      };
    },

    imageKey() {
      switch (this.entityType) {
        case "challenge":
          return null; // member challenges don't have the maps relation and so don't have an image ...
        case "team":
          return "logo";
        default:
          return null;
      }
    },

    dataFiltered() {
      return this.data.map(item => {
        let subtitle = `${
          this.date(item.startDate, "DATE_FORMAT_SLASH").formatted
        } - ${this.date(item.endDate, "DATE_FORMAT_SLASH").formatted}`;
        item.subtitle = subtitle;
        return item;
      });
    }
  },

  methods: {
    isPaginated() {
      return this.paginated && this.data.length > this.pageSize;
    },

    entityId(entity) {
      return this.to === "Teams" ? entity.teamNameURL : entity.id;
    }
  }
};
</script>

<style lang="sass" scoped>
.wt-entity-list
  position: relative
  min-height: 60px
  .wt-entity-list-title
  .wt-entity-list-view-all
    position: absolute
    top: 0
    right: 0
  .wt-entity-list-heading
    border-top: .5px solid $grey-light
  .wt-entity-list-body
    margin-bottom: 1rem
  .wt-entity-list-body-item
    padding: .25rem 0 .5rem 0
    border-top: .5px solid $grey-light
    &:hover
      background-color: $grey-lighter
  .wt-entity-list-footer
    width: 100%
</style>
